import { Radio } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import FilterItem from 'src/components/Search/Common/Filters/FilterItem';
import FilterWrapper from 'src/components/Search/Common/Filters/FilterWrapper';
import { useApplyFilter } from 'src/components/Search/Common/Filters/hooks/useApplyFilter';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { ClusterKey } from 'src/types/search/common/clusters';

const TrlKeys = {
    title: 'resume.relocation',
};

const Relocation: TranslatedComponent = ({ trls }) => {
    const applyFilter = useApplyFilter(ClusterKey.Relocation);
    const { groups, selectedValues } = useSelector((state) => state.searchClusters[ClusterKey.Relocation]);

    return (
        <FilterWrapper filterKey={ClusterKey.Relocation} title={trls[TrlKeys.title]}>
            {Object.values(groups).map((item) => (
                <FilterItem
                    key={item.id}
                    left={
                        <Radio
                            value={item.id}
                            onChange={() => applyFilter(item.id)}
                            checked={selectedValues === item.id}
                            dataQaRadio={`serp__novafilter-${ClusterKey.Relocation}-${item.id}`}
                        />
                    }
                    title={item.title}
                />
            ))}
        </FilterWrapper>
    );
};

export default translation(Relocation);
